<!-- 页脚 -->
<template>
  <div class="foot-comp">
    <div class="content-size">
      <div class="foot-con clearfix">
        <div class="contact left">
          <strong>0571-88862015</strong>
          <p>周一至周五 9:00~17:00</p>
          <p>合作邮箱：service@hzty.com</p>
        </div>
        <ul class="right">
          <li
            class="product left"
            v-for="(item, index) in productList"
            :key="index"
          >
            <img
              :src="'@/../static/img/product/' + index + '.png'"
              alt=""
              :onerror="$parent.imgError"
            />
            <p>{{ item }}</p>
          </li>
        </ul>
      </div>
      <ul class="foot-nav clearfix">
        <li
          class="left"
          v-for="(item, index) in navList"
          :key="index"
          @click="goPage(index)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="copyright">
      <div class="content-size">
        <p>
          Copyright@ 2013 杭州天音计算机系统工程有限公司 All Rights Reserved
          <a href="http://beian.miit.gov.cn/" target="_blank">浙B2-20080204</a>
        </p>
        <p>
          <span class="security"
            >网络文化经营许可证：浙网文[2019] 1389-151 号</span
          >
          <span class="security">浙公网安备33010602002528号</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      navList: ["关于我们", "产品方案", "公司案例", "合作代理"],
      productList: [
        "快乐学堂学生端APP",
        "学趣乐园APP",
        "棒小孩APP",
        "师生通APP"
      ]
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    goPage(index) {
      if (index == 0) {
        this.$router.push({ path: "/about", query: {} });
      } else if (index == 1) {
        this.$router.push({ path: "/product", query: {} });
      } else if (index == 2) {
        this.$router.push({ path: "/case", query: {} });
      } else if (index == 3) {
        this.$router.push({ path: "/cooperate", query: {} });
      }
    }
  }
};
</script>
<style type="text/css" scoped>
.content-size {
  width: 1392px;
  margin: 0 auto;
}
.foot-comp {
  /* width: 100%;
    position: absolute;
    left: 0;
    bottom: 0; */
  background: #2f313e;
}
.foot-con {
  color: #fff;
  padding: 70px 0 90px;
}
.contact strong {
  display: block;
  font-size: 36px;
  line-height: 1;
  margin-bottom: 30px;
}
.contact p {
  font-size: 16px;
  line-height: 28px;
}
.product {
  width: 130px;
  text-align: center;
}
.product img {
  width: 80px;
  height: 80px;
  border: 5px solid #fff;
}
.product p {
  line-height: 1;
  padding-top: 16px;
}
.foot-nav {
  padding-bottom: 22px;
  width: 500px;
  margin: 0 auto;
}
.foot-nav li {
  padding: 0 30px;
  border-right: 1px solid #fff;
  color: #fff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
.foot-nav li:last-child {
  border-right: 0;
}
.copyright {
  border-top: 1px solid #444652;
  color: #7f8086;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}
.copyright p {
  height: 30px;
  line-height: 30px;
}
.copyright p a {
  color: #7f8086;
}
.security {
  margin-left: 20px;
  /* background: url(~@/assets/img/icon/security.png) no-repeat 0 center;
    background-size: 20px auto;  */
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue